import type { Dispatch } from "@reduxjs/toolkit";

export const RESET_CREATE_TICKET = "RESET_CREATE_TICKET";
export const CREATE_TICKET_NOTE = "CREATE_TICKET_NOTE";
export const CREATE_TICKET_NOTE_COMPLETE = "CREATE_TICKET_NOTE_COMPLETE";
export const CREATE_TICKET_NOTE_ERROR = "CREATE_TICKET_NOTE_ERROR";
export const DOWNLOAD_TICKET_ATTACHMENT = "DOWNLOAD_TICKET_ATTACHMENT";
export const DOWNLOAD_TICKET_ATTACHMENT_COMPLETE =
  "DOWNLOAD_TICKET_ATTACHMENT_COMPLETE";
export const DOWNLOAD_TICKET_ATTACHMENT_ERROR =
  "DOWNLOAD_TICKET_ATTACHMENT_ERROR";
export const GET_TICKET_ATTACHMENT_INFO = "GET_TICKET_ATTACHMENT_INFO";
export const GET_TICKET_ATTACHMENT_INFO_COMPLETE =
  "GET_TICKET_ATTACHMENT_INFO_COMPLETE";
export const GET_TICKET_ATTACHMENT_INFO_ERROR =
  "GET_TICKET_ATTACHMENT_INFO_ERROR";
export const RESET_TICKET_NOTE_SUBMITTED = "RESET_TICKET_NOTE_SUBMITTED";

export function resetTicketNoteSubmitted() {
  return (dispatch: Dispatch) => {
    dispatch({
      type: RESET_TICKET_NOTE_SUBMITTED,
    });
  };
}

export function resetTicketSubmission() {
  return (dispatch: Dispatch) => {
    dispatch({
      type: RESET_CREATE_TICKET,
    });
  };
}

export function createTicketNote(ticketNote: unknown) {
  return (dispatch: Dispatch) => {
    dispatch({
      type: CREATE_TICKET_NOTE,
      payload: {
        data: ticketNote,
      },
    });
  };
}

export function downloadAttachment(guid: string) {
  return (dispatch: Dispatch) => {
    dispatch({
      type: DOWNLOAD_TICKET_ATTACHMENT,
      payload: {
        data: guid,
      },
    });
  };
}

export function getTicketAttachments(id: number | string) {
  return (dispatch: Dispatch) => {
    dispatch({
      type: GET_TICKET_ATTACHMENT_INFO,
      payload: {
        data: id,
      },
    });
  };
}
